import React from 'react'
import Hero from '../components/HeroSection'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'


const Home = () => {
   return (
      <div>
         <Navbar/>
         <Hero />
         <Footer />
      </div>
   )
}

export default Home
